import React, { useState, useEffect } from "react";
import { Skeleton } from 'antd';
import "./index.scss";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";

const LoginPage = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {}, []);

  return (
    <div className="login">
      <div className="container text-center">
        <img className="logo" width="auto" src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol.png" alt="Daol" />
        <div className="box">
          <div className="box-contant">
            <label className="label">กำลังโหลดข้อมูล</label>
            {/* <p className="text-gray text-loading">กรุณารอสักครู่...</p> */}
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
